import React from 'react';
import { AccordionContent, AccordionGroup } from 'core/controls';
import { TranslateContext } from 'core/translate';
import MotorizationOption from './MotorizationOption';
import OptionsAccordionHeader from './OptionsAccordionHeader';

const MotorizationOptionGroup = ({ options, onChange }) => {
  if (options.length <= 1) {
    return null;
  }

  return (
    <TranslateContext.Consumer>
      {translate => {
        const header = translate('component.common.select.motorization');

        const optionList = options.map(option => (
          <MotorizationOption
            key={option.id}
            option={option}
            analyticsKey={header}
            onChange={onChange}
          />
        ));

        return (
          <AccordionGroup id="configuration-motorizations">
            <OptionsAccordionHeader header={header} count={options.length} />
            <AccordionContent>{optionList}</AccordionContent>
          </AccordionGroup>
        );
      }}
    </TranslateContext.Consumer>
  );
};

export default MotorizationOptionGroup;
